var dropdownItem = 'fx_c76f37be_x6ok2c0';
var dropdownItemClickable = 'fx_c76f37be_x6ok2c1';
var dropdownItemContent = 'fx_c76f37be_x6ok2c2';

export { dropdownItem, dropdownItemClickable, dropdownItemContent };
//# sourceMappingURL=item.vanilla.mjs.map
